import { Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-con-timestamp',
  templateUrl: './d-con-timestamp.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DConTimestampComponent),
      multi: true
    }
  ]
})
export class DConTimestampComponent extends DynamicComponentBase {
  static KEY = 'd-con-timestamp';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {}
}
